import { render, staticRenderFns } from "./StsgForm.vue?vue&type=template&id=391820c1"
import script from "./StsgForm.vue?vue&type=script&lang=js"
export * from "./StsgForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports